import React from "react";

// Extracted from app.jsx.
//
// app.jsx is the 13-surface design workbench, and it imports the admin console,
// the email gallery, the error-code gallery and every prototype screen. site.jsx
// called useTheme() on every page render, so that one import pulled the whole
// workbench into the initial bundle — 560 KB of JavaScript, 151 KB gzipped, for
// a customer who wanted to send one postcard.
//
// This audience is overwhelmingly on phones, frequently on metered or prepaid
// data. Shipping them an operator console to render a landing page is a cost
// they pay in money, not just milliseconds.
//
// Kept as its own module with no imports beyond React so that nothing can
// accidentally chain a heavy dependency back into every page.
export function useTheme() {
  const [mode, setMode] = React.useState(() => localStorage.getItem("cc-theme") || "dark");
  React.useEffect(() => {
    const apply = () => {
      let t = mode;
      if (mode === "system") {
        t = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
      }
      document.documentElement.setAttribute("data-theme", t);
    };
    apply();
    localStorage.setItem("cc-theme", mode);
    if (mode === "system") {
      const mq = window.matchMedia("(prefers-color-scheme: dark)");
      mq.addEventListener("change", apply);
      return () => mq.removeEventListener("change", apply);
    }
  }, [mode]);
  return [mode, setMode];
}
